const createPt120InitState = () => ({
  productInfo: [],
  navList: [],
  colSizList: [],
  favoritesList: [],
  totalReviewRank: [],
  uketoriServiceKbn: {},
  descriptionInfo: {},
  pt400DescriptionInfo: {},
  sh030DescriptionInfo: {},
  sh050DescriptionInfo: {},
  sh060DescriptionInfo: {},
  colorTitle: '',
  sizeTitle: '',
  syukkaYoteiDate: '',
  siteFlg: null,
  priceFlg: null,
  facebookUrl: null,
  facebookAttr: null,
  loginKbn: false,
  shahanFlg: null,
  colorSizeFlg: false,
  reviewList: null,
  itemStdFlg: 0,
});

const createPt120ReqModelState = () => ({
  sItemNo: null,
  colSzSItemNo: null,
  yoyakuItemFlg: null,
  categoryCd: null,
  buyCount: null,
  wariPrice: null,
  cartAddKbn: null,
  pointFlg: 0,
  agreeFlag: 0,
  kokyakuCd: null,
  mail: null,
  mailOld: null,
  mail_confirm: null,
  password: null,
  passwordSub: null,
  prePassword: null,
  nm1: null,
  nm2: null,
  nm3: null,
  kana1: null,
  kana2: null,
  kana3: null,
  birthDayYYYY: null,
  birthDayMM: null,
  birthDayDD: null,
  sexKbn: '9',
  zip: null,
  zip1: null,
  zip2: null,
  kenCd: null,
  kenNm: null,
  addr1: null,
  addr2: null,
  addr3: null,
  tel1: null,
  fax: null,
  newsMailRcvFlg: '0',
  dmFlg: '0',
  kokyakuRankKbn: null,
  kokyakuRankKbnNm: null,
  pointNum: null,
  exclCnt: null,
  nickname: null,
  ageOpenFlg: '0',
  sexOpenFlg: '0',
  kaiinCheck: null,
  radioGroup: '1',
  tdkNo: '0',
  tdkNm1: '',
  tdkNm2: '',
  tdkKana1: '',
  tdkKana2: '',
  tdkZip: '',
  tdkKenCd: '',
  tdkKenNm: '',
  tdkAddr1: '',
  tdkAddr2: '',
  tdkAddr3: '',
  tdkTel: '',
  tdkMail1: '',
  kessaiCd: null,
  sagyoKanriKomokuCd: null,
  sagyoKanriKomokuCd2: null,
  noshiNaire1: null,
  noshiNaire2: null,
  securityCode: '',
  cardSecurity: '',
  sbp3DVerFlg: 0,
  tds2InfoToken: '',
  tds2InfoTokenKey: '',
  sbp3DVerBackUr: '',
  tdsAuthenticationId: '',
  resSbpCustId: '',
  apiRequestId: '',
  resApiErrCode: '',
  resApiResult: '',
});

const state = () => ({
  pt120Init: createPt120InitState(),
  pt120ReqModel: createPt120ReqModelState(),
});

const mutations = {
  RESET_PT120_STATE(currentState) {
    currentState.pt120Init = createPt120InitState();
    currentState.pt120ReqModel = createPt120ReqModelState();
  },
  SET_PT120_INIT(currentState, payload = {}) {
    currentState.pt120Init = payload || {};
  },
  MERGE_PT120_INIT(currentState, payload = {}) {
    currentState.pt120Init = Object.assign({}, currentState.pt120Init, payload);
  },
  SET_PT120_REQ_MODEL(currentState, payload = {}) {
    currentState.pt120ReqModel = payload || {};
  },
  MERGE_PT120_REQ_MODEL(currentState, payload = {}) {
    currentState.pt120ReqModel = Object.assign({}, currentState.pt120ReqModel, payload);
  },
};

const getters = {
  pt120Init: currentState => currentState.pt120Init,
  pt120ReqModel: currentState => currentState.pt120ReqModel,
};

export {
  createPt120InitState,
  createPt120ReqModelState,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
